<template>
    <div id="main">
        <div class="page dont-break-word">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-niveltecnologico') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('agro-niveltecnologico') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!nivelTecnologicoIntegracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-niveltecnologico-new' })"
                        >
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-5">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-nivel-tecnologico"
                        />
                    </div>

                    <div class="column is-4">
                        <vss-select
                            ref="empresaInput"
                            title="empresa"
                            placeholder="selecione"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            :loading="empresasLoading"
                            @search="carregarEmpresas"
                            @input="carregarDados()"
                            :height="40"
                        />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            ref="situacaoInput"
                            title="situacao"
                            :options="situacoes"
                            :mlLabels="true"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                            :height="40"
                            :clearable="true"
                        />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="allniveltecnologico"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'agro-niveltecnologico-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="props.row[f.key] == 1 ? 'is-success' : 'is-danger'"
                                    size="is-medium"
                                >
                                    {{ $t(props.row[f.key] == 1 ? 'ativo' : 'inativo') }}
                                </b-tag>
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <span v-if="!nivelTecnologicoIntegracao && permissao.update">
                                    <b-button
                                        v-if="permissao.update"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['situacao'] == 1
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </span>
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/agro/nivel-tecnologico/NivelTecnologicoService';
import NivelTecnologicoService from '@/services/agro/nivel-tecnologico/NivelTecnologicoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import CulturaService from '@/services/agro/CulturaService';

/* @71147 - aba nível tecnológico */
/* @71282 - listagem do nível tecnológico */
export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            nivelTecnologicoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_NIVELTECNOLOGICO'
            ),
            allniveltecnologico: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new NivelTecnologicoService(this.$http, this.$router),
            serviceCultura: new CulturaService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: 100, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true },
                { key: 'empresa', width: null, sortable: true },
                { key: 'cultura', width: null, sortable: true },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            delete: null,
            permissao: {},
            order: 'desc',
            column: 'DESCRICAO',
            empresaSelect: [{ id: 0, label: this.$t('todos') }],
            empresaSelected: { id: 0, label: this.$t('todos') },
            empresasLoading: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-niveltecnologico'
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-niveltecnologico' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            this.carregarEmpresas();
        }
    },
    methods: {
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;

            let params = [
                this.queryFilter != '' ? this.queryFilter : '.*',
                this.empresaSelected.id,
            ];
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allniveltecnologico = value;
                    this.isEmpty = this.allniveltecnologico.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os níveis tecnológicos.');
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((nivelTech) => {
                return {
                    id: nivelTech.idagroniveltecnologico,
                    codigo: nivelTech.idagroniveltecnologicoerp,
                    idsafra: nivelTech.idsafra,
                    cultura: nivelTech.cultura ? nivelTech.cultura.descricao : '',
                    idempresa: nivelTech.idempresa,
                    empresa: nivelTech.empresa.nome,
                    descricao: nivelTech.descricao,
                    excluir: 'excluir',
                    situacao: nivelTech.situacao,
                };
            });
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findEmpresa(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[FENOLOGIA] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[FENOLOGIA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.empresa.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('[FENOLOGIA] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    //preenche automaticamente se só tiver um valor
                    if (this.empresaSelect.length == 1 && !this.cantEdit) {
                        this.empresaSelected = this.empresaSelect[0];
                    }
                    if (
                        this.empresaSelected == null &&
                        this.isUpdate &&
                        this.nivelTecnologico.idempresa > 0
                    ) {
                        let tempEmpresa = this.empresaSelect.filter(
                            (e) => e.id == this.nivelTecnologico.idempresa
                        );
                        if (tempEmpresa.length > 0) {
                            this.empresaSelected = tempEmpresa[0];
                        }
                    }
                    this.empresasLoading = false;
                });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-nivel-tecnologico'
                    : 'msg-erro-ao-reativar-nivel-tecnologico';

            let tempNivelTecnologico = {
                idagroniveltecnologico: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempNivelTecnologico)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-nivel-tecnologico'
                                : 'msg-sucesso-ao-desativar-nivel-tecnologico';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>
